export const isNullOrBlank = (val: string | undefined | null): boolean => {
  return val === undefined || val === null || val.trim().length === 0;
}

export const isNotBlank = (val: string | undefined | null) =>
  val !== undefined
  && val !== null
  && val.trim().length > 0;

export const normalizeForSearch = (s: string): string => s.toLowerCase()
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "");

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const isValidEmail = (val: string): boolean => {
  return emailRegex.test(val.trim());
}


// WEBPACK FOOTER //
// ./src/utils/string-utils.tsx